/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// React
import { useEffect, useState } from 'react';

// UI lib components
import { Box } from '@mantine/core';

// UI local components
import { BackgroundImageAuth } from '@features/auth/components/BackgroundImageAuth';
import { FooterInfo } from '@features/auth/components/FooterInfo';
import { ForgotPassword } from '@features/auth/components/ForgotPassword/ForgotPassword';
import { SignIn } from '@features/auth/components/SignIn';
import packageJson from '../../../../../package.json';

// Styles
import classes from './login.module.css';

// Constants
import { Text } from '@components/v2/ui';
import {
	BG_INUK,
	BG_INUK_MOBILE,
	BG_INUK_TABLET,
	CONTACT_US_INUK_URL,
} from '@config/constants/common';
import { useBreakpoint } from '@hooks/useBreakpoint';
import { queryClient } from '@lib/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

const Auth = () => {
	/* ********************************** STATE ********************************* */
	const [authForm, setAuthForm] =
		useState<string>('signin');
	const { isTablet } = useBreakpoint();
	const navigate = useNavigate();
	/* ******************************** HELPERS ******************************* */
	const handlenavigate = (_target: string) => {
		setAuthForm(_target);
	};
	const { t, i18n } = useTranslation();
	const NavigateComponents = () => {
		if (authForm === 'signin')
			return <SignIn handlenavigate={handlenavigate} />;
		if (authForm === 'reset')
			return (
				<ForgotPassword handlenavigate={handlenavigate} />
			);
		return null;
	};
	useEffect(() => {
		queryClient.clear();
	}, []);

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Box className={classes.leftContainer}>
				<Box className={classes.backgroundImageMobile}>
					<BackgroundImageAuth
						url={
							isTablet ? BG_INUK_TABLET : BG_INUK_MOBILE
						}
					/>
				</Box>

				<Box
					className={classes.containerFormTabletMobile}
				>
					{NavigateComponents()}
					<FooterInfo
						contactUsUrl={CONTACT_US_INUK_URL}
					/>
				</Box>

				<Box className={classes.containerFormDesktop}>
					{NavigateComponents()}
					<FooterInfo
						contactUsUrl={CONTACT_US_INUK_URL}
					/>
				</Box>
				<Box
					style={{
						height: '100%',
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'flex-end',
					}}
					mt={'12px'}
					w={'70%'}
				>
					<Box
						style={{
							cursor: 'pointer',
						}}
						onClick={() => {
							navigate(`/cgu/${i18n.language}`);
						}}
					>
						<Text variant="caption" c={'#1D3965'}>
							{t('global.termsOfUse')}
						</Text>
					</Box>
					<Text variant="caption" c={'#1D3965'}>
						V {packageJson.version}
					</Text>
				</Box>
			</Box>

			<Box className={classes.rightContainer}>
				<BackgroundImageAuth url={BG_INUK} />
			</Box>
		</Box>
	);
};

export default Auth;
